import axios from 'axios'
import { getIdToken } from '@/auth/cognito'

// Only our own API Gateway endpoints get the token (not ipify, Google, etc.).
const API_PREFIXES = [
  process.env.VUE_APP_BASE_GATEWAY_URL,
  process.env.VUE_APP_PUBLIC_GATEWAY_URL,
].filter(Boolean)

function isBackendUrl (url) {
  return !!url && API_PREFIXES.some(prefix => url.startsWith(prefix))
}

export function installAuthInterceptor () {
  axios.interceptors.request.use(async config => {
    if (!isBackendUrl(config.url) || config.auth) return config
    config.headers = config.headers || {}
    if (config.headers.Authorization) return config
    // getIdToken() refreshes an expired session using the refresh token.
    const token = await getIdToken()
    if (token) config.headers.Authorization = 'Bearer ' + token
    return config
  })
}
